
import upArrow from "assets/images/organisationProfile/setup/select arrow.svg";
import upArrowdark from "assets/images/organisationProfile/setup/selectArowdark.svg";
import React, { useEffect, useRef, useState } from "react";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
import useTheme from "hooks/observer";
import SquareCheckBox from "components/SquareCheckBox/index";
import "./CreateTeamRoles.scss";
import Button from "components/Button/index";
import { Role as IzRole} from "@induz/sdk";

const CreateTeamRoles = ({ updateOperations, initialOperations = [] }) => {
  const theme = useTheme();
  const arrow = theme === "light" ? upArrow : upArrowdark;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasSelectionBeenConfirmed, setHasSelectionBeenConfirmed] = useState(
    !!initialOperations.length
  );
  const [dropdownData, setDropdownData] = useState([]); // State for API-fetched data
  const [checkedStates, setCheckedStates] = useState([]);
  const dropdownRef = useRef(null);


 useEffect(() => {
    const fetchRolesFromWasm = async () => {
      try {
        const roleNames = await IzRole.listRoleNames(); // Call exported WASM function

        // Sort case-sensitively to help differentiate between similar names
        const sortedRoleNames = [...roleNames].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "case" }));
        const roles = sortedRoleNames.map((n) => ({ role: n }));
        setDropdownData(roles);
        setCheckedStates(
          roles.map((op) =>
            initialOperations.some((o) => typeof o === "string" ? o === op.role :o.role === op.role)
          )
        );
      } catch (error) {
        console.error("Error loading roles from WASM:", error);
      }
    };

    fetchRolesFromWasm();
  }, [initialOperations]);

  const handleCheckboxChange = (index) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = !newCheckedStates[index];
    setCheckedStates(newCheckedStates);
  };

  const truncateName = (name) => {
    const parts = name.split(" ");
    if (parts.length > 1) {
      return `${parts[0]} ${parts[1].charAt(0)}...`;
    }
    return name.length > 8 ? `${name.substring(0, 8)}...` : name;
  };

  const selectedRoles = dropdownData.filter((_, index) => checkedStates[index]);

  const filteredDropdownData = dropdownData.filter((role) =>
    role.role.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // console.log("filteredDropdownData", filteredDropdownData);

  const renderSelectedRoles = () => (
    <div className="selected-users-container">
      {!hasSelectionBeenConfirmed ? (
        <>
          <input
            type="text"
            placeholder="Select roles"
            className="user-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => setIsDropdownOpen(true)}
          />
          <img
            src={arrow}
            alt="arrow"
            className="dropdown-arrow"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          />
        </>
      ) : (
        <>
          <div className="user-chips">
            {selectedRoles.slice(0, 1).map((role, index) => (
              <span key={index} className="user-chip">
                {truncateName(role.role)}
              </span>
            ))}
            {selectedRoles.length > 1 && (
              <span className="remaining-count">
                +{selectedRoles.length - 1}
              </span>
            )}
          </div>
          <div
            className="cross"
            onClick={() => {
              setCheckedStates(Array(dropdownData.length).fill(false));
              setSearchTerm("");
              setHasSelectionBeenConfirmed(false);
            }}
          >
            <GetActionIcon
              type="cross"
              color={theme === "light" ? "#7D708A" : "#BDB8C2"}
            />
          </div>
        </>
      )}
    </div>
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="CreateTeamRoles">
      <div className="CreateTeamRolesWrapper">
        <div className="CreateTeamRolesWrapperContent" ref={dropdownRef}>
          <p>Add Roles</p>
          <div className="CreateTeamRolesselectUser">
            <div className="user" onClick={() => setIsDropdownOpen(true)}>
              {renderSelectedRoles()}
            </div>
            {isDropdownOpen && (
              <div className="RolesDropdown">
                <ul>
                  {filteredDropdownData.map((option, index) => (
                    <li
                      key={option.role}
                      className="NotificationItem"
                      onClick={() => handleCheckboxChange(index)}
                    >
                      <SquareCheckBox
                        labelStyles={{
                          color: "var(--text-grey-strong)",
                          fontFamily: "Helvetica, sans-serif"
                        }}
                        isChecked={checkedStates[index]}
                        handleCheck={() => handleCheckboxChange(index)}
                      />
                      <div className="content">
                        <p>{option.role}</p>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="RolesDropdownButtons">
                  <Button
                    type="white"
                    title="Clear"
                    width="50%"
                    onClick={() => {
                      setCheckedStates(Array(dropdownData.length).fill(false));
                      setSearchTerm("");
                      setHasSelectionBeenConfirmed(false);
                    }}
                  />
                  <Button
                    type="violet"
                    title="Select"
                    width="50%"
                    onClick={() => {
                      setIsDropdownOpen(false);
                      setHasSelectionBeenConfirmed(true);
                      // Comment: Pass selected roles to parent, which will handle API creation
                      updateOperations(selectedRoles);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTeamRoles;